export const messageFormError = {
  canNotIncludeCharacter: 'Không được chứa các ký tự < > { } [ ]'
};

export default messageFormError;
